import { render, staticRenderFns } from "./properties-component-glyph.vue?vue&type=template&id=6690f094&scoped=true"
import script from "./properties-component-glyph.vue?vue&type=script&lang=js"
export * from "./properties-component-glyph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6690f094",
  null
  
)

export default component.exports